import React from "react";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import styles from "./styles.css";
import ComingSoon from "./images/coming-soon-illustration.png";
import { sendCustomGaEvents } from "../../../tracking";
import { changeLocation } from "./tracking";
import { getGaEventDimensionObject } from "../../../utils/helpers/get-ga-event-object";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Label } from "@cars24/turbo-web/lib/label";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { Button } from "@cars24/turbo-web/lib/button";
import PrefixIcon from "./prefix-icon";

const ComingSoonCityModal = ({
    isComingSoon,
    toggleLocationPickerConnect,
    setComingSoonConnect,
    selectedCity = {},
    isLoggedIn,
    userId
}) => {

    const { tokens } = useTokens();

    const {name: cityName, id: cityId} = selectedCity || {};

    const dimensionObject = getGaEventDimensionObject({
        isLoggedIn,
        cityId,
        cityName,
        userId
    });
    const toggle = () => {
        setComingSoonConnect(false);
        toggleLocationPickerConnect();
        sendCustomGaEvents({
            ...changeLocation,
            ...dimensionObject,
            eventLabel: selectedCity.name
        });
    };
    return (
        <React.Fragment>
            {isComingSoon &&
            <Modal isOpen={true} overlayClass={"comingSoonOverlay"}>
                <div styleName={"styles.comingSoonWrapper"}>
                    <div className={"container"}>
                        <div styleName={"styles.comingSoonContent"}>

                            <div>
                                <div styleName={"styles.content"}>
                                    <Label
                                        level={1}
                                        color={tokens.text_default_text_primary}
                                        fontWeight="semibold"
                                    >We are coming soon!
                                    </Label>
                                    <BodyText
                                        color={tokens.text_default_text_secondary}
                                        level={3}>
                                        We are currently not active in this city, but <br /> expanding soon to your region.
                                    </BodyText>
                                </div>

                                <Button
                                    label="Change location"
                                    onClick={toggle}
                                    size="large"
                                    variant="primary"
                                    prefixIcon={<PrefixIcon/>}
                                />
                            </div>

                            <img styleName={"styles.modalImage"} src={ComingSoon} alt="We are coming soon!" />
                        </div>
                    </div>
                </div>
            </Modal>}
        </React.Fragment>
    );
};

ComingSoonCityModal.propTypes = {
    isComingSoon: PropTypes.bool,
    toggleLocationPickerConnect: PropTypes.func,
    setComingSoonConnect: PropTypes.func,
    selectedCity: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    userId: PropTypes.string
};

export default ComingSoonCityModal;
